<template>
	
	<!-- Main Sidebar -->
	<component :is="navbarFixed ? 'a-affix' : 'div'" :offset-top="top" class="header-bg">

		<!-- Layout Header -->
		<a-layout-header>
			<a-row type="flex">

				<!-- Header Breadcrumbs & Title Column -->
				<a-col :span="20" :md="8" :lg="6">
					<div class="brand">
						<img src="/images/adbox_logo_174x64.png" @click="reloadPage" class="logo-lg" alt="ScamLock" />
					</div>
					<!-- Header Breadcrumbs -->
				</a-col>
				<a-col :span="4" :md="16" :lg="18" class="header-col header-nav text-align-center font-10">
					<a-menu mode="horizontal" class="menu-large hide-on-med-and-down">
						<a-menu-item v-if="currentRouteName !== 'About Us'">
							<router-link :to="{name: 'About Us'}" class="nav-link">
								<span>About Us</span>
							</router-link>
						</a-menu-item>
						<a-menu-item v-if="currentRouteName !== 'ScamLock Document Verified'">
							<router-link :to="{name: 'ScamLock Document Verified'}" class="nav-link">
								<span>Verify Document</span>
							</router-link>
						</a-menu-item>
						<a-menu-item v-if="currentRouteName !== 'ScamLock'">
							<router-link :to="{name: 'ScamLock'}" class="nav-link">
								<span>Verify Product</span>
							</router-link>
						</a-menu-item>
						<a-menu-item v-if="currentRouteName !== 'Verification Sites'">
							<router-link :to="{name: 'Verification Sites'}" class="nav-link">
								<span>Verification Sites</span>
							</router-link>
						</a-menu-item>
						<a-menu-item v-if="currentRouteName !== 'Product Pre-Registration'">
							<router-link :to="{name: 'Product Pre-Registration'}" class="nav-link">
								<span>Pre-Registration</span>
							</router-link>
						</a-menu-item>
						<a-menu-item v-if="currentRouteName !== 'Terms and Conditions'">
							<router-link :to="{name: 'Terms and Conditions'}" class="nav-link">
								<span>Terms & Conditions</span>
							</router-link>
						</a-menu-item>
						<a-menu-item v-if="currentRouteName !== 'ScamLock Agent Verified'">
							<router-link :to="{name: 'ScamLock Agent Verified'}" class="nav-link">
								<span>Verify Agent</span>
							</router-link>
						</a-menu-item>
						<a-menu-item v-if="currentRouteName !== 'ScamLock Promo Verified'">
							<router-link :to="{name: 'ScamLock Promo Verified'}" class="nav-link">
								<span>Verify Promotion</span>
							</router-link>
						</a-menu-item>
						<a-menu-item v-if="currentRouteName !== 'ScamLock Caller ID Check'">
							<router-link :to="{name: 'ScamLock Caller ID Check'}" class="nav-link">
								<span>Caller ID Check</span>
							</router-link>
						</a-menu-item>
					</a-menu>

					<a-button type="link" @click="collapseNav = collapseNav ? 0 : 1 " class="btn-menu-trigger hide-on-large-only">
						<svg width="20" height="20" fill="#d1b82c" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"/></svg>
					</a-button>
				</a-col>

				<div class="menu-small hide-on-large-only" v-if="collapseNav">

					<!-- Collapsible Component For Navigation Menu For Small Screens -->
					<a-menu mode="inline"
							:open-keys="openKeys"
							@openChange="onOpenChange"
					>
						<a-menu-item v-if="currentRouteName !== 'About Us'">
							<router-link :to="{name: 'About Us'}" class="nav-link">
								<span>About Us</span>
							</router-link>
						</a-menu-item>
						<a-menu-item v-if="currentRouteName !== 'ScamLock Document Verified'">
							<router-link :to="{name: 'ScamLock Document Verified'}" class="nav-link">
								<span>Verify Document</span>
							</router-link>
						</a-menu-item>
						<a-menu-item v-if="currentRouteName !== 'ScamLock'">
							<router-link :to="{name: 'ScamLock'}" class="nav-link">
								<span>Verify Product</span>
							</router-link>
						</a-menu-item>
						<a-menu-item v-if="currentRouteName !== 'Verification Sites'">
							<router-link :to="{name: 'Verification Sites'}" class="nav-link">
								<span>Verification Sites</span>
							</router-link>
						</a-menu-item>
						<a-menu-item v-if="currentRouteName !== 'Product Pre-Registration'">
							<router-link :to="{name: 'Product Pre-Registration'}" class="nav-link">
								<span>Pre-Registration</span>
							</router-link>
						</a-menu-item>
						<a-menu-item v-if="currentRouteName !== 'Terms and Conditions'">
							<router-link :to="{name: 'Terms and Conditions'}" class="nav-link">
								<span>Terms & Conditions</span>
							</router-link>
						</a-menu-item>
						<a-menu-item v-if="currentRouteName !== 'ScamLock Agent Verified'">
							<router-link :to="{name: 'ScamLock Agent Verified'}" class="nav-link">
								<span>Verify Agent</span>
							</router-link>
						</a-menu-item>
						<a-menu-item v-if="currentRouteName !== 'ScamLock Promo Verified'">
							<router-link :to="{name: 'ScamLock Promo Verified'}" class="nav-link">
								<span>Verify Promotion</span>
							</router-link>
						</a-menu-item>
						<a-menu-item v-if="currentRouteName !== 'ScamLock Caller ID Check'">
							<router-link :to="{name: 'ScamLock Caller ID Check'}" class="nav-link">
								<span>Caller ID Check</span>
							</router-link>
						</a-menu-item>
					</a-menu>
					<!-- / Navigation Menu For Small Screens -->
					<!-- / Collapsible Component For Navigation Menu For Small Screens -->

				</div>

			</a-row>

		</a-layout-header>
		<!--  /Layout Header -->

	</component>
	<!-- / Main Sidebar -->

</template>

<script>

	const notificationsData = [
		{
			title: 'New message from Sophie',
			img: 'images/face-1.jpg',
			time: '13 minutes ago',
		},
		{
			title: 'New album by Travis Scott',
			svg: `<svg width="20" height="20" viewBox="0 0 107 107" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
					<title>logo-spotify</title>
					<g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
						<g id="logo-spotify" fill="#2EBD59" fill-rule="nonzero">
							<path d="M53.5,0 C23.9517912,0 0,23.9517912 0,53.5 C0,83.0482088 23.9517912,107 53.5,107 C83.0482088,107 107,83.0482088 107,53.5 C107,23.9554418 83.0482088,0.00365063118 53.5,0 Z M78.0358922,77.1597407 C77.0757762,78.7368134 75.0204708,79.2296486 73.4506994,78.2695326 C60.8888775,70.5922552 45.0743432,68.8582054 26.4524736,73.1111907 C24.656363,73.523712 22.8675537,72.3993176 22.458683,70.6032071 C22.0461617,68.8070966 23.1669055,67.0182873 24.9666667,66.6094166 C45.3444899,61.9548618 62.8273627,63.9590583 76.9297509,72.5745479 C78.4995223,73.5419652 78.9996588,75.5899693 78.0358922,77.1597407 L78.0358922,77.1597407 Z M84.5814739,62.5973729 C83.373115,64.5614125 80.8030706,65.1747185 78.8426817,63.9700102 C64.4664961,55.1318321 42.5408052,52.5727397 25.5325145,57.7347322 C23.3275333,58.4027977 20.9984306,57.1579324 20.3267144,54.9566018 C19.6622996,52.7516206 20.9071648,50.4261685 23.1084954,49.7544524 C42.5371546,43.858683 66.6933811,46.7134766 83.2051859,56.8622313 C85.1692255,58.0705902 85.7898328,60.636984 84.5814739,62.5973729 Z M85.1436711,47.4253497 C67.8980894,37.1853292 39.4523712,36.2434664 22.9880246,41.2375299 C20.3449676,42.0406687 17.5485841,40.5475606 16.7490959,37.9045036 C15.9496076,35.2614466 17.4390652,32.4650631 20.0857728,31.6619243 C38.9850904,25.9267827 70.3987718,27.0329239 90.2509041,38.8171614 C92.627465,40.2299556 93.4087001,43.3001365 91.9995565,45.6730467 C90.5940635,48.0532583 87.5165814,48.838144 85.1436711,47.4253497 Z" id="Shape"></path>
						</g>
					</g>
				</svg>`,
			time: '1 day ago',
		},
		{
			title: 'Payment completed',
			svg: `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path fill="#1890FF" d="M4 4C2.89543 4 2 4.89543 2 6V7H18V6C18 4.89543 17.1046 4 16 4H4Z"/>
					<path fill="#1890FF" fill-rule="evenodd" clip-rule="evenodd" d="M18 9H2V14C2 15.1046 2.89543 16 4 16H16C17.1046 16 18 15.1046 18 14V9ZM4 13C4 12.4477 4.44772 12 5 12H6C6.55228 12 7 12.4477 7 13C7 13.5523 6.55228 14 6 14H5C4.44772 14 4 13.5523 4 13ZM9 12C8.44772 12 8 12.4477 8 13C8 13.5523 8.44772 14 9 14H10C10.5523 14 11 13.5523 11 13C11 12.4477 10.5523 12 10 12H9Z"/>
				</svg>`,
			time: '2 days ago',
		},
	] ;

	export default ({
		components: {
		},
		props: {
			// Header fixed status.
			navbarFixed: {
				type: Boolean,
				default: false,
			},

			// Sidebar collapsed status.
			sidebarCollapsed: {
				type: Boolean,
				default: false,
			},

			// Header notifications data.
			notificationsData: {
				type: Array,
				default: () => notificationsData,
			},
		},
		data() {
			return {
                // Collapse navigation value.
                // Binded model property for "Collapsible Navigation Menu" collapsed status .
                collapseNav: 0,
                // Sidebar collapsed status.
				// Fixed header/sidebar-footer ( Affix component ) top offset.
				top: 0,

				// Search input loading status.
				searchLoading: false,

				// The wrapper element to attach dropdowns to.
				wrapper: document.body,
                rootSubmenuKeys: [],
                openKeys: null,
			}
		},
		methods: {
            onOpenChange(openKeys)
            {
                this.openKeys = this.openKeys ? this.openKeys : this.$route.meta.sidebarMap ;

                const latestOpenKey = openKeys.find( key => this.openKeys.indexOf( key ) === -1) ;

                if ( this.rootSubmenuKeys.indexOf( latestOpenKey ) === -1 )
                {
                    this.openKeys = openKeys;
                }
                else
                {
                    this.openKeys = latestOpenKey ? [ latestOpenKey ] : [] ;
                }
            },
            reloadPage()
			{
			    /*window.location.reload();*/
            	this.$router.push({name: "ScamLock"});
			},
			resizeEventHandler(){
				this.top = this.top ? 0 : -0.01 ;
				// To refresh the header if the window size changes.
				// Reason for the negative value is that it doesn't activate the affix unless
				// scroller is anywhere but the top of the page.
			},
			onSearch(value){
			}
		},
		mounted: function(){
			// Set the wrapper to the proper element, layout wrapper.
			this.wrapper = document.getElementById('layout-dashboard') ;
		},
		created() {
			// Registering window resize event listener to fix affix elements size
			// error while resizing.
			window.addEventListener("resize", this.resizeEventHandler);
		},
		destroyed() {
			// Removing window resize event listener.
			window.removeEventListener("resize", this.resizeEventHandler);
		},
		computed: {
		    currentRouteName() {
		        return this.$route.name;
			}
		}
	})

</script>
<style>
	.brand {
		padding-left: 30px;
		padding-top: 10px;
	}
	.brand img.logo-lg, .brand img.logo-sm {
		max-height: 30px;
	}
	.header-bg {
		background-color: #252525;
	}
	.header-bg .ant-menu,
	.header-bg .ant-menu-horizontal > .ant-menu-item > a,
	.header-bg .ant-menu-item > a
	{
		color: white !important;
	}
	.header-bg .ant-menu .ant-menu-submenu-title:hover {
		color: #d1b82c !important;
		border-color: #d1b82c !important;
	}
	.header-bg .ant-menu-item > a:hover {
		color: #d1b82c !important;
	}

	.header-bg .ant-menu-submenu, .header-bg .ant-menu-submenu > .ant-menu {
		background-color: #252525 !important;
	}
	.header-bg .ant-menu-inline {
		border-right: none !important;
	}


	.header-bg .ant-menu-horizontal > .ant-menu-item:hover,
	.header-bg .ant-menu-horizontal > .ant-menu-submenu:hover,
	.header-bg .ant-menu-horizontal > .ant-menu-item-active,
	.header-bg .ant-menu-horizontal > .ant-menu-submenu-active,
	.header-bg .ant-menu-horizontal > .ant-menu-item-open,
	.header-bg .ant-menu-horizontal > .ant-menu-submenu-open,
	.header-bg .ant-menu-horizontal > .ant-menu-item-selected,
	.header-bg .ant-menu-horizontal > .ant-menu-submenu-selected {
		color: #d1b82c !important;
		border-bottom: 2px solid #d1b82c !important;
	}
	.header-bg .ant-menu-horizontal {
		border-bottom: none !important;
	}

	.header-bg .ant-menu-horizontal {
		float: right !important;
	}

</style>
